import Items from '../../components/Items/items'
import Schedule from '../../components/schedule/schedule'
import LinksProfileProfessional from '../../components/links-profile/links'
import LinksProfileCompany from '../../components/links-profile-company/links'
import MbSelect from '../../components/select/select'

export default {
  Items,
  Schedule,
  LinksProfileProfessional,
  LinksProfileCompany,
  MbSelect
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/gadget/resources/components.js